import { AutocompleteInputModel, CheckboxInputModel, SelectInputModel, SubmitGroupItemModel } from '@libs/form/models';

export const bffEnvMap: Record<string, string> = {
  local: 'http://localhost:3333',
  netlify: 'https://dce-bff.netlify.app/.netlify/functions/gateway',
  dev: 'https://gateway.dev.lekkerland.io/bff',
  stage: 'https://gateway.stage.lekkerland.io/bff',
  prod: 'https://gateway.lekkerland.io/bff',
};

export const bffEnvConfig: SelectInputModel = {
  type: 'select',
  name: 'bff-url',
  label: 'Environment',
  options: Object.keys(bffEnvMap).map(key => ({ label: key, value: key })),
  attributes: {
    required: true,
  },
};

export const pageRootConfig: AutocompleteInputModel = {
  type: 'autocomplete',
  name: 'content-root',
  label: 'Content Root',
  options: [
    { label: '2800 :: Main', value: '2800' },
    { label: '3106 :: Angebote', value: '3106' },
    { label: '3107 :: Marken', value: '3107' },
    { label: '1877 :: Sortiment', value: '1877' },
    { label: '2798 :: Layout', value: '2798' },
    { label: '2799 :: Test', value: '2799' },
    { label: '81 :: Shop (alles)', value: '81' },
  ],
  attributes: {
    spellcheck: false,
    required: true,
  },
};

export const showNavigationConfig: CheckboxInputModel = {
  type: 'checkbox',
  name: 'show-navigation',
  label: 'Show navigation',
};

export const submitConfig: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'apply',
      label: 'Apply',
      theme: 'filled',
    },
  ],
};
